import { Converter } from 'showdown';
/**
 * Converts markdown text strings into HTML
 *
 * Preconfigured with the options we support.
 */
export const markdownConverter = new Converter({
    emoji: true,
    literalMidWordUnderscores: true,
    smoothLivePreview: true,
    smartIndentationFix: true,
    simpleLineBreaks: true,
    strikethrough: true,
    disableForced4SpacesIndentedSublists: true,
    tables: true,
    underline: true,
    omitExtraWLInCodeBlocks: true,
    tasklists: true,
    backslashEscapesHTMLTags: true,
    openLinksInNewWindow: true,
    ghCodeBlocks: true, // enable github-style fenced code blocks
});
